import { Injectable } from '@angular/core';
import {
  HttpResponse,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, timer } from 'rxjs';
import { LoaderService } from './loader.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
@Injectable()
export class InterceptorService implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];
  constructor(private loaderService: LoaderService, private spinner: NgxSpinnerService, private router: Router) { }
  private activeRequests = 0;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isHappyTravelersPage = this.router.url.startsWith('/happy-travelers');
    const isAITripSecondPage = this.router.url.startsWith('/ai-trip-second');
    const isAIitineraryPage = this.router.url.startsWith('/ai-itinerary');
    if (this.activeRequests === 0) {
      if (!isAITripSecondPage && !isAIitineraryPage) {
        if (isHappyTravelersPage) {
          this.showLoader(true); // immediate
        } else {
          this.showLoader(false); // delayed
        }
      }
    }

    this.activeRequests++;

    return next.handle(req).pipe(
      tap(
        // event => console.log(event),
        // error => console.error(error)
      ),
      finalize(() => {
        this.activeRequests--;
        if (this.activeRequests === 0) {
          this.hideLoader(); // Hide loader only when all requests are complete
        }
      })
    );
  }

  // private showLoader() {
  //   const loader = document.getElementById('custom-loader');
  //   if (loader) {
  //     loader.classList.add('show');
  //   }
  // }

  private loaderTimeout: any;

  private showLoader(immediate = false) {
    if (immediate) {
      clearTimeout(this.loaderTimeout);
      const loader = document.getElementById('custom-loader');
      if (loader) {
        loader.classList.add('show');
      }
    } else {
      this.loaderTimeout = setTimeout(() => {
        const loader = document.getElementById('custom-loader');
        if (loader) {
          loader.classList.add('show');
        }
      }, 4000);
    }
  }

  private hideLoader() {
    clearTimeout(this.loaderTimeout);
    const loader = document.getElementById('custom-loader');
    if (loader) {
      loader.classList.remove('show');
    }
  }


  // private hideLoader() {
  //   const loader = document.getElementById('custom-loader');
  //   if (loader) {
  //     loader.classList.remove('show');
  //   }
  // }

}